export default __webpack_public_path__ + "static/media/VINCULAR.0797d3bb.svg";